export const saveState = (state) => {
  try {
    // Only save if state is valid and not empty
    if (state && Object.keys(state).length > 0) {
      const serialState = JSON.stringify(state);
      localStorage.setItem("appState", serialState);
    }
  } catch (err) {
  }
};

export const loadState = () => {
  const paths = window.location.pathname.split("/");
  try {
    const serialState = localStorage.getItem("appState");
    if (serialState === null) {
      return undefined;
    }
    const jsonData = JSON.parse(serialState);
    const otherPaths = ["payment-callback"];
    
    // Check if hotel data exists and has hotelKey
    const hasValidHotelData = jsonData.hotel && jsonData.hotel.hotelKey;
    
    if (
      (hasValidHotelData && jsonData.hotel.hotelKey === paths?.[1]) ||
      otherPaths.indexOf(paths?.[1]) > -1
    ) {
      return jsonData;
    }
    
    // If no valid hotel data or hotel key mismatch, return cart and user data
    return { 
      user: jsonData?.user,
      cart: jsonData?.cart || { data: [], priceSummary: { subTotal: 0, deliveryCharge: 0, serviceCharge: 0, discount: 0, tax: 0, total: 0 } },
      order: jsonData?.order || { orderId: null, paymentId: null, orderHistory: [] }
    };
  } catch (err) {
    return undefined;
  }
};